import { useState } from 'react';

import { Box, Button, TextField, Typography } from '@mui/material';

interface WizardNameStepProps {
  onNext: (name: string) => void;
  initialValue?: string;
}

export const WizardNameStep = ({ onNext, initialValue = '' }: WizardNameStepProps) => {
  const [name, setName] = useState(initialValue);

  const handleNext = () => {
    if (name.trim()) {
      onNext(name);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Name Your Integration
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Give your integration a descriptive name that explains what it does
      </Typography>

      <TextField
        fullWidth
        label="Integration Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="e.g., Canvas to Salesforce Student Sync"
        helperText="Choose a name that describes the source, destination, and purpose"
        sx={{ mb: 3 }}
      />

      <Button variant="contained" onClick={handleNext} disabled={!name.trim()}>
        Next
      </Button>
    </Box>
  );
};
